<template>
    <el-dialog
        :title="$tt('批量设置当前页面的按钮')"
        :visible="isShowModal"
        width="78%"
        top="8vh"
        custom-class="batch-set-btn-dialog"
        @close="hide"
        :destroy-on-close="true"
    >
        <div class="batch-set-toolbar">
            <el-input
                v-model="searchForm.propValue"
                size="small"
                clearable
                :placeholder="$tt('按钮名称')"
                class="batch-search-input"
            />
            <el-input
                v-model="searchForm.alias"
                size="small"
                clearable
                :placeholder="$tt('别名')"
                class="batch-search-input"
            />
            <el-button size="small" @click="resetSearch">{{ $tt("重置") }}</el-button>
            <div class="batch-set-toolbar-right">
                <span class="batch-set-count">{{ $tt("共") }} {{ filteredDatas.length }} {{ $tt("个") }}</span>
                <el-button type="primary" size="small" @click="batchSet">{{ $tt("批量设置") }}</el-button>
            </div>
        </div>
        <el-table
            :data="filteredDatas"
            border
            style="width: 100%"
            :max-height="tableMaxH"
            @selection-change="handleCheckedChange"
        >
            <el-table-column type="selection" width="48" fixed="left"></el-table-column>
            <el-table-column prop="order" :label="$tt('序号')" width="56" align="center" fixed="left">
                <template slot-scope="scope">
                    {{scope.$index + 1}}
                </template>
            </el-table-column>
            <el-table-column :label="$tt('缩略图')" width="88" align="center" fixed="left">
                <template slot-scope="scope">
                    <div class="btn-thumb" :style="thumbStyle(scope.row)">
                        <span>{{ thumbText(scope.row) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                v-for="cell in allCells"
                :key="cell.key"
                :prop="cell.key"
                :align="cell.align || 'center'"
                :min-width="cell.width"
                :label="$tt(cell.label)"
                :fixed="cell.fixed"
                :show-overflow-tooltip="imgKes.indexOf(cell.key) === -1"
                :sortable="imgKes.indexOf(cell.key) === -1 && colorKeys.indexOf(cell.key) === -1"
            >
                <template slot-scope="scope">
                    <span v-if="cell.key === 'fontFamily'">{{fontFamilyName(scope.row.style[cell.key])}}</span>
                    <span v-else-if="notStyleKeys.indexOf(cell.key) !== -1">{{scope.row[cell.key]}}</span>
                    <template v-else-if="imgKes.indexOf(cell.key) !== -1">
                        <img v-if="scope.row.style[cell.key]" class="batch-set-btn-imgs" :src="getPicSrc(scope.row.style[cell.key])" />
                        <span v-else class="batch-empty">—</span>
                    </template>
                    <span v-else-if="colorKeys.indexOf(cell.key) !== -1" class="color-cell">
                        <i v-if="scope.row.style[cell.key]" class="color-swatch" :style="{ background: scope.row.style[cell.key] }"></i>
                        <span>{{ scope.row.style[cell.key] || '—' }}</span>
                    </span>
                    <span v-else>{{scope.row.style[cell.key]}}</span>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="hide">{{ $tt("取 消") }}</el-button>
            <el-button size="small" type="primary" @click="confirm">{{ $tt("确 定") }}</el-button>
        </span>
        <BatchSetBtnsAttr
            ref="batchSetBtnsAttrDialog"
            @confirm="btnAttrSetConfirm"
        />
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
import { fontFamilyOptions } from '@/utils/attrNameData';
import BatchSetBtnsAttr from './BatchSetBtnsAttr';

export default {
    data() {
        return {
            fontFamilyOptions,
            isShowModal: false,
            searchForm: {
                propValue: '',
                alias: ''
            },
            allCells: [
                { label: "按钮名称", key: "propValue", width: "100", fixed: 'left' },
                { label: "按压名称", key: "btnPressName", width: "100" },
                { label: "别名", key: "alias", width: "120" },
                { label: "字体颜色", key: "color", width: "110" },
                { label: "背景图", key: "backgroundImage", width: "88" },
                { label: "背景颜色", key: "backgroundColor", width: "110" },
                { label: "按压背景图", key: "pressBackgroundImage", width: "88" },
                { label: "按压背景颜色", key: "pressBackgroundColor", width: "120" },
                { label: "字体", key: "fontFamily", width: "120" },
                { label: "字体大小", key: "fontSize", width: "80" }
            ],
            notStyleKeys: ['propValue'],
            imgKes: ['backgroundImage', 'pressBackgroundImage'],
            colorKeys: ['color', 'backgroundColor', 'pressBackgroundColor'],
            allDatas: [],
            checkDatas: [],
            tableMaxH: 420
        };
    },
    components: {
        BatchSetBtnsAttr
    },
    computed: {
        ...mapState(["componentData"]),
        filteredDatas() {
            const name = (this.searchForm.propValue || '').trim().toLowerCase();
            const alias = (this.searchForm.alias || '').trim().toLowerCase();
            return (this.allDatas || []).filter((row) => {
                if (name && String(row.propValue || '').toLowerCase().indexOf(name) === -1) {
                    return false;
                }
                const rowAlias = (row.style && row.style.alias) || row.alias || '';
                if (alias && String(rowAlias).toLowerCase().indexOf(alias) === -1) {
                    return false;
                }
                return true;
            });
        },
        fontFamilyName() {
            return (val) => {
                if (val) {
                    let data = this.fontFamilyOptions.filter((c) => c.id === val);
                    return data && data[0] && data[0].text || '';
                }
                return '';
            }
        },
        getPicSrc() {
            return (src) => {
                if (!src) return '';
                if (src.indexOf('(') !== -1 && src.indexOf(')') !== -1) {
                    return src.split("(")[1]?.split(")")[0];
                } else {
                    return src;
                }
            };
        },
    },
    methods: {
        show() {
            this.searchForm = { propValue: '', alias: '' };
            this.allDatas = JSON.parse(JSON.stringify(this.componentData.filter((c) => c.component === "v-button")));
            this.tableMaxH = Math.max(280, (typeof window !== 'undefined' ? window.innerHeight : 800) - 280);
            this.isShowModal = true;
        },
        hide() {
            this.isShowModal = false;
        },
        resetSearch() {
            this.searchForm = { propValue: '', alias: '' };
        },
        thumbText(row) {
            const t = (row && row.propValue) || '';
            return t.length > 4 ? t.slice(0, 4) : t;
        },
        thumbStyle(row) {
            const st = (row && row.style) || {};
            const img = this.getPicSrc(st.backgroundImage);
            const style = {
                borderRadius: row.type === 'round' ? '50%' : ((st.borderRadius || 0) + 'px'),
                color: st.color || '#fff',
                backgroundColor: st.backgroundColor || '#409eff',
            };
            if (img) {
                style.backgroundImage = 'url(' + img + ')';
                style.backgroundSize = 'cover';
                style.backgroundPosition = 'center';
            }
            return style;
        },
        confirm() {
            this.$emit('confirm', this.allDatas);
            this.hide();
        },
        btnAttrSetConfirm(datas) {
            if (Object.keys(datas).length === 0) {
                return;
            }
            this.checkDatas.map((item) => {
                let dataInd = this.allDatas.findIndex((c) => c.id === item.id);
                Object.keys(datas).map((key) => {
                    if (key === 'style') {
                        Object.keys(datas[key]).map((styleKey) => {
                            this.allDatas[dataInd][key][styleKey] = datas[key][styleKey];
                        });
                    } else {
                        this.allDatas[dataInd][key] = datas[key];
                    }
                });
            });
        },
        batchSet() {
            if (this.checkDatas.length == 0) {
                this.$message.error('请先勾选要批量设置的按钮');
                return;
            }
            this.$refs.batchSetBtnsAttrDialog.show();
        },
        handleCheckedChange(s) {
            this.checkDatas = s;
        }
    }
}
</script>
<style lang="scss">
.batch-set-btn-dialog {
    border-radius: 8px;
    .el-dialog__header {
        padding: 14px 20px 10px;
        border-bottom: 1px solid #ebeef5;
    }
    .el-dialog__body {
        padding: 12px 20px;
    }
    .el-dialog__footer {
        padding: 10px 20px 16px;
        border-top: 1px solid #ebeef5;
    }
    .el-table {
        border-radius: 6px;
    }
    .el-table__empty-block {
        min-height: 80px;
    }
    .batch-set-toolbar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
    }
    .batch-search-input {
        width: 160px;
    }
    .batch-set-toolbar-right {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .batch-set-count {
        font-size: 12px;
        color: #909399;
    }
    .batch-set-btn-imgs {
        width: 48px;
        height: 32px;
        object-fit: cover;
        border-radius: 4px;
        vertical-align: middle;
    }
    .batch-empty {
        color: #c0c4cc;
    }
    .btn-thumb {
        width: 56px;
        height: 32px;
        margin: 0 auto;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        line-height: 1.1;
        box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
        span {
            padding: 0 2px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 100%;
        }
    }
    .color-cell {
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }
    .color-swatch {
        width: 14px;
        height: 14px;
        border-radius: 3px;
        border: 1px solid #e4e7ed;
        display: inline-block;
        flex-shrink: 0;
    }
}
</style>
